import { z } from "zod";
import { DefaultRangeSchema } from "./common";

export const SavedSearchSourceSchema = z.enum([
  "log_analytics",
  "ga4",
  "auth0",
]);
export type SavedSearchSource = z.infer<typeof SavedSearchSourceSchema>;

export const SavedSearchSchema = z.object({
  id: z.string(),
  orgId: z.string(),
  ownerId: z.string(),
  name: z.string(),
  source: SavedSearchSourceSchema,
  query: z.string(),
  defaultRange: DefaultRangeSchema.nullable(),
  createdAt: z.string(),
});
export type SavedSearch = z.infer<typeof SavedSearchSchema>;

export const SavedSearchesListSchema = z.array(SavedSearchSchema);
export type SavedSearchesList = z.infer<typeof SavedSearchesListSchema>;

export const CreateSavedSearchBodySchema = z.object({
  name: z.string().min(1).max(120),
  source: SavedSearchSourceSchema,
  query: z.string().min(1).max(100_000),
  defaultRange: DefaultRangeSchema.optional(),
});
export type CreateSavedSearchBody = z.infer<typeof CreateSavedSearchBodySchema>;
